import { render, staticRenderFns } from "./UiCard.vue?vue&type=template&id=4f6bf24a&scoped=true"
import script from "./UiCard.vue?vue&type=script&lang=js"
export * from "./UiCard.vue?vue&type=script&lang=js"
import style0 from "./UiCard.vue?vue&type=style&index=0&id=4f6bf24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6bf24a",
  null
  
)

export default component.exports